import { useEffect, useState } from 'react';
import { node } from 'prop-types';

/**
 * Utility component to only render children client-side on the second render pass.
 * @see {@link https://react.dev/reference/react-dom/client/hydrateRoot#handling-different-client-and-server-content | React Documentation}
 */
const ClientOnly = ({
  children
}) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  return isClient ? children : null;
};
ClientOnly.propTypes = {
  /** The children which should only render on the client */
  children: node.isRequired
};
export default ClientOnly;